module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "staking-rewards.629f8782.svg";